import { Download, Loader2 } from "lucide-react";
import { useState } from "react";
import { download, type ExportLink } from "./exports";

/**
 * Download buttons for a set of exports. A refusal is shown beside them in the server's words.
 * Read-only, so every signed-in role gets them.
 */
export function ExportButtons({ links, label }: { links: ExportLink[]; label?: string }) {
  const [busy, setBusy] = useState<string | null>(null);
  const [problem, setProblem] = useState<string | null>(null);

  const go = async (link: ExportLink) => {
    setBusy(link.href);
    setProblem(null);
    try {
      await download(link);
    } catch (e) {
      setProblem(`${link.label}: ${e instanceof Error ? e.message : String(e)}`);
    } finally {
      setBusy(null);
    }
  };

  return (
    <div>
      <div className="row" style={{ gap: 8, flexWrap: "wrap" }} role="group" aria-label={label ?? "Downloads"}>
        {links.map((link) => (
          <button key={link.href} className="ghost" onClick={() => void go(link)} disabled={busy !== null}
                  title={`Download ${link.filename}`}>
            {busy === link.href ? <Loader2 size={14} className="spin" aria-hidden="true" /> : <Download size={14} aria-hidden="true" />}
            {" "}{link.label}
          </button>
        ))}
      </div>
      {problem && <p className="muted" role="alert" style={{ color: "var(--color-fail)", marginTop: 6, fontSize: 13 }}>{problem}</p>}
    </div>
  );
}
